import ItemIcon19 from "../../images/icons/h-1.svg";
import ItemIcon20 from "../../images/icons/h-2.svg";
import ItemIcon21 from "../../images/icons/h-3.svg";
import ItemIcon22 from "../../images/icons/h-4.svg";
import ItemIcon23 from "../../images/icons/h-5.svg";
import Node from "../../images/edge.png";
import Node2 from "../../images/edge2.png";
import Node3 from "../../images/edge3.png";
// import Node4 from "../../images/edge4.png";
import Node4 from "../../images/edge4Hoz.png";

import Node5 from "../../images/edge5.png";


export const PointData = [
  {
    id: 1,
    icon: ItemIcon19,
    img: Node3,
    smt: "Authentication",
    title: "Authentication Through Edge Nodes",
    description:
      "In blockchain networks, authentication through edge nodes enables Decentralized identity verification closer to the user, improving speed and reducing latency.",
  },
  {
    id: 2,
    icon: ItemIcon20,
    img: Node,
    smt: "Decentralized Communication",
    title: "Decentralized Routing for Communication",
    description:
      "Decentralized routing allows data to be transmitted across a network without relying on a central authority.",
  },
  {
    id: 3,
    icon: ItemIcon21,
    img: Node2,
    smt: "Decentralized Communication",
    title: "Enhanced Performance and Security",
    description:
      "Decentralized systems improve performance and security by distributing workloads and data across multiple nodes.",
  },
  {
    id: 4,
    icon: ItemIcon22,
    img: Node4,
    title: "Offload Processing Tasks",
    description:
      "Offloading processing tasks distributes workloads from a central server to multiple edge devices or nodes.",
  },
  {
    id: 5,
    img: Node5,
    icon: ItemIcon23,
    title: "Edge Processing with AI and ML Models",
    description:
      "Edge processing with AI and machine learning models allows data analysis and decision-making directly on edge devices.",
  },
];
